export const HANG_CALL_STATUS = ['originated', 'initiated', 'ringing', 'in-progress', null, undefined];

export const FALLBACK_MAX_CALL_DURATION = 15 * 60; // 15 MINUTES
